import { AgreementResponse, IdentifierType } from '@/api/types';
import { FinalizeOptions } from '@/hooks/useLoginFinalize';
import { SignInRoutes } from '@/Routes';
import { useSessionConfig } from '@/store/sessionConfigStore';
import { useSignInStore } from '@/store/signInStore';
import { useRouter } from 'next/navigation';
import { useHandleSessionState } from './useHandleSessionState';

export type VerificationOptions = FinalizeOptions & {
  mergeAgreements?: boolean;
};

export const useHandleSignInVerification = () => {
  const router = useRouter();

  const handleSessionState = useHandleSessionState();

  const updateVerificationResult = useSignInStore(
    (s) => s.updateVerificationResult,
  );
  const searchForPlans = useSessionConfig((s) => s.searchForPlans);
  const requirePlans = useSessionConfig((s) => s.requirePlans);
  const isPhoneIdentifier = useSignInStore(
    (s) => s.session.identifierType === IdentifierType.PHONE,
  );

  return async (
    { additionalValidations, validatedAgreements }: AgreementResponse,
    elementId: string,
    options?: VerificationOptions,
  ) => {
    updateVerificationResult(
      { additionalValidations, validatedAgreements },
      options?.mergeAgreements,
    );

    if (!searchForPlans) {
      await handleSessionState(elementId, options);
      return;
    }

    if (additionalValidations) {
      if (validatedAgreements?.length) {
        router.push(SignInRoutes.PLANS);
      } else {
        router.push(SignInRoutes.VERIFY_LAST_NAME_POSTAL_CODE);
      }
    } else if (
      (isPhoneIdentifier || requirePlans) &&
      !validatedAgreements?.length
    ) {
      router.push(SignInRoutes.NO_PLANS);
    } else {
      await handleSessionState(elementId, options);
    }
  };
};
